import { Card, Loading } from '@sede-enterprise/shell-ds-react-framework'
import React, { useEffect, useState } from 'react'
import useGetCorrosionAlertsCount from './hooks/useGetCorrosionAlertsCount'
import PieChart from '../../components/PieChart/PieChart';
import useGetRemnantAlertsCount from './hooks/useGetRemnantAlertsCount';
import { clickFilterHandler, getInitialData, updateColorsForUnmatchedLabels } from './util/alertsPieChartUtils';


const AlertsPieChart = ({ filters, applyPieFilters, clearPieFilters, filterType, setPieFilterType }) => {

    const { data: corrosionAlertsCount, loading } = useGetCorrosionAlertsCount(filters);
    const { data: remnantAlertsCount, loading: remnantCountLoading } = useGetRemnantAlertsCount(filters);

    const [corrosionDataToPlot, setCorrosionDataToPlot] = useState([])
    const [remnantDataToPlot, setRemnantDataToPlot] = useState([])

    useEffect(() => {
        getInitialData(corrosionAlertsCount, remnantAlertsCount, setCorrosionDataToPlot, setRemnantDataToPlot);
    }, [corrosionAlertsCount, remnantAlertsCount])


    return (
        <div className='alerts-cards-container'>

            <Card className='alerts-card' bodyPadding={false}>
                {loading && <div className='loading-container' role='status'><Loading /></div>}
                {corrosionAlertsCount && !corrosionAlertsCount.category.length && <div className='empty-pie'>
                    <h4>Corrosion Rate Alerts</h4>
                    <div className='empty-pie-body'>
                        <p className='data-value'>No Data under this category</p>
                    </div>
                </div>}
                {corrosionAlertsCount && corrosionAlertsCount.category.length > 0 && <PieChart
                    onPieClick={(pieData) => clickFilterHandler(
                        pieData,
                        applyPieFilters,
                        corrosionDataToPlot,
                        remnantDataToPlot,
                        setCorrosionDataToPlot,
                        setRemnantDataToPlot,
                        (dataToPlot, targetLabel, type) =>
                            updateColorsForUnmatchedLabels(dataToPlot, targetLabel, type, setPieFilterType)
                    )}
                    clearPieFilters={() => {
                        setPieFilterType(null)
                        clearPieFilters()
                        getInitialData(corrosionAlertsCount, remnantAlertsCount, setCorrosionDataToPlot, setRemnantDataToPlot);
                    }}
                    data={corrosionDataToPlot}
                    selectedPieFilterType={filterType}
                    pieFilterType={'corrosion'}
                    title={'Corrosion Rate Alerts'}
                    helpText={"This depicts the number of alerts generated over the given period whenever the threshold has been crossed. Click on the Pie to filter the types of alerts. Alerts list by clicking on Pie Chart"}
                />}

            </Card>

            <Card className='alerts-card' bodyPadding={false}>
                {remnantCountLoading && <div className='loading-container' role='status'><Loading /></div>}
                {remnantAlertsCount && !remnantAlertsCount.eventCode.length && <div className='empty-pie'>
                    <h4>Remnant Life Alerts</h4>
                    <div className='empty-pie-body'>
                        <p className='data-value'>No Data under this category</p>
                    </div>
                </div>}
                {remnantAlertsCount && remnantAlertsCount.eventCode.length > 0 && <PieChart
                    onPieClick={(pieData) => clickFilterHandler(
                        pieData,
                        applyPieFilters,
                        corrosionDataToPlot,
                        remnantDataToPlot,
                        setCorrosionDataToPlot,
                        setRemnantDataToPlot,
                        (dataToPlot, targetLabel, type) =>
                            updateColorsForUnmatchedLabels(dataToPlot, targetLabel, type, setPieFilterType)
                    )}
                    clearPieFilters={() => {
                        setPieFilterType(null)
                        clearPieFilters()
                        getInitialData(corrosionAlertsCount, remnantAlertsCount, setCorrosionDataToPlot, setRemnantDataToPlot);
                    }}
                    data={remnantDataToPlot}
                    selectedPieFilterType={filterType}
                    pieFilterType={'remnant'}
                    title={'Remnant Life Alerts'}
                    helpText={"This depicts the number of alerts generated over the given period whenever the threshold has been crossed. Click on the Pie to filter the types of alerts. Alerts list by clicking on Pie Chart"}
                />}
            </Card>
        </div>
    )
}

export default AlertsPieChart